// Đọc bí mật (API key, PAT, token) qua stdin thay vì argv.
//
// VÌ SAO: argv của mọi tiến trình đọc được bằng `ps -ef` từ user khác trên cùng
// máy, và bị process manager / CI ghi vào log. stdin không nằm trong bảng tiến
// trình. Quy ước cờ: `--<domain>-<field>-stdin` bật đường này.

import type { Readable } from "node:stream";

/** Giới hạn kích thước để một stdin không bao giờ đóng không ăn hết bộ nhớ. */
const MAX_SECRET_BYTES = 64 * 1024;

/**
 * Đọc toàn bộ stdin, trả chuỗi đã cắt khoảng trắng hai đầu.
 *
 * Cắt `\n` cuối là bắt buộc: `echo "$KEY" | avatar …` luôn kèm newline, để lọt
 * thì key sai mà thông báo lỗi lại nói "key không hợp lệ" — cực khó truy.
 */
export async function readSecretFromStdin(stream: Readable = process.stdin): Promise<string> {
  const chunks: Buffer[] = [];
  let total = 0;

  for await (const chunk of stream) {
    const buf = Buffer.isBuffer(chunk) ? chunk : Buffer.from(String(chunk));
    total += buf.length;
    if (total > MAX_SECRET_BYTES) {
      throw new Error(
        `Bí mật đọc từ stdin vượt ${MAX_SECRET_BYTES} byte — nhiều khả năng sai nguồn`,
      );
    }
    chunks.push(buf);
  }

  return Buffer.concat(chunks).toString("utf8").trim();
}

/**
 * Đọc bí mật nếu cờ `*-stdin` được bật, ngược lại trả `undefined`.
 *
 * Gộp vào đây để 3 cụm T1/T2/T3 không mỗi nơi tự viết một nhánh `if`.
 */
export async function readSecretIfRequested(
  useStdin: boolean | undefined,
  stream: Readable = process.stdin,
): Promise<string | undefined> {
  if (useStdin !== true) return undefined;
  const secret = await readSecretFromStdin(stream);
  return secret === "" ? undefined : secret;
}
